import { render, staticRenderFns } from "./section2.vue?vue&type=template&id=1799dec6&"
import script from "./section2.vue?vue&type=script&lang=js&"
export * from "./section2.vue?vue&type=script&lang=js&"
import style0 from "./section2.vue?vue&type=style&index=0&id=1799dec6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports